import { CoveredMatrixMarketWatch } from "src/Interfaces/coveredMatrixOrder";
import { TseIconLink } from "../Display";

interface Props {
  name: string;
  marketWatch?: CoveredMatrixMarketWatch | null;
  referencePrice?: number | null;
  tseLink?: string;
  account: string;
  holding: string;
  imbalance: string;
}

export const BaseInstrumentInfo = ({ name, marketWatch, referencePrice, tseLink, account, holding, imbalance }: Props) => {
  const format = (value?: number | null) => value == null ? "-" : value.toLocaleString();
  const reference = referencePrice ?? marketWatch?.lastPrice;
  const difference = (price?: number | null) => {
    if (reference == null || price == null || price <= 0) return null;
    return Math.round((reference - price) / price * 10000) / 100;
  };
  const prices = [["آخرین", marketWatch?.lastPrice], ["پایانی", marketWatch?.tradePrice]] as const;
  const values = [marketWatch?.buyVolume, marketWatch?.buyPrice, marketWatch?.sellPrice, marketWatch?.sellVolume];

  return <div className="min-w-0 self-start overflow-hidden rounded border border-gray-300 bg-white px-2 py-1.5 text-xs" dir="rtl">
    <div className="flex items-center gap-1.5 pb-1.5 font-semibold">
      <span>نماد پایه: {name || "-"}</span>
      <TseIconLink href={tseLink || marketWatch?.tseLink} />
    </div>
    <table className="w-full table-fixed border-collapse text-center">
      <thead><tr>
        {["حجم", "خرید", "فروش", "حجم"].map((label, index) => <th key={index} className={`border border-slate-300 px-1 py-0.5 ${index < 2 ? "bg-[#a8dfbd] text-green-900" : "bg-[#f8c5d2] text-slate-900"}`}>{label}</th>)}
      </tr></thead>
      <tbody><tr>
        {values.map((value, index) => {
          const isValid = index < 2 ? marketWatch?.buyOrderBookIsValid : marketWatch?.sellOrderBookIsValid;
          return <td key={index} className={`border border-slate-300 px-1 py-1 ${index < 2 ? "bg-[#eaf8ef]" : "bg-[#fde9ed]"} ${isValid === false ? "text-gray-300" : "text-gray-800"}`}>{format(value)}</td>;
        })}
      </tr></tbody>
    </table>
    <div className="mt-4 overflow-hidden rounded border-2 border-sky-100">
      <table className="w-full table-fixed border-collapse text-center text-[10px] leading-4">
        <tbody>
          <tr>
            <td rowSpan={2} className="border border-gray-200 px-1 py-1 align-middle">مبنا: <span dir="ltr">{format(reference)}</span></td>
            {prices.map(([label, value]) => <td key={label} className="border border-gray-200 px-1 py-1">{label}: <span dir="ltr">{format(value)}</span></td>)}
          </tr>
          <tr>
            {prices.map(([label, value]) => {
              const delta = difference(value);
              return <td key={label} dir="ltr" className={`border border-gray-200 px-1 py-1 ${delta == null || delta === 0 ? "text-gray-600" : delta > 0 ? "text-green-600" : "text-red-600"}`}>
                {delta == null ? "-" : `${delta.toFixed(2)}%`}
              </td>;
            })}
          </tr>
        </tbody>
      </table>
    </div>
    <div className="mt-3 space-y-1 px-1">
      <div className="truncate" title={account}>اکانت: {account}</div>
      <div className="truncate" title={holding}>تعداد در پورتفو: {holding}</div>
      <div className="truncate" title={imbalance}>ناترازی گروه پرتفو برای این نماد پایه: {imbalance}</div>
    </div>
  </div>;
};
